import { useRouter } from "next/navigation";
import { useEffect } from "react";

export function ClientRouterProvider() {
  const router = useRouter();

  useEffect(() => {
    window.__APP_ROUTER__ = router;
  }, [router]);

  return null;
}
